import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './Footer.css';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <Container>
        <p className="footer-text">
          {t('footer.copyright')}
        </p>
      </Container>
    </footer>
  );
}

export default Footer;
